export interface TabItem {
  id: number;
  label: string;
}

export const resolveTabId = <T extends readonly TabItem[]>(
  raw: string | null,
  tabs: T,
): number | null => {
  if (raw == null) return null;

  const value = Number(raw);
  if (!Number.isInteger(value)) return null;
  if (!tabs.some((tab) => tab.id === value)) return null;

  return value;
};

export const parseTabId = <T extends readonly TabItem[]>(
  raw: string | null,
  tabs: T,
  fallback = 0,
): number => resolveTabId(raw, tabs) ?? fallback;

export const getTabLabel = (
  tabs: readonly TabItem[],
  id: number,
): string | undefined => tabs.find((tab) => tab.id === id)?.label;

export const hasLegacySubTabQuery = (searchParams: URLSearchParams): boolean =>
  searchParams.has("subTab");
